import { RootState } from 'src/store';

import { IPayoutAvailableMethod, IPayoutAvailableMethodData } from './types';

export const selectPayoutAvailableMethodsData = (state: RootState): Partial<IPayoutAvailableMethodData> =>
  state.payoutAvailableMethods.methods.data;
export const selectIPayoutAvailableMethodDataLoading = (state: RootState): boolean => state.payoutAvailableMethods.methods.isLoading;
export const selectIPayoutAvailableMethodDataLoaded = (state: RootState): boolean => state.payoutAvailableMethods.methods.isLoaded;
export const selectIPayoutAvailableMethod = (state: RootState): Partial<IPayoutAvailableMethod> => state.payoutAvailableMethods.method.data;
export const selectPayoutAvailableMethodLoading = (state: RootState): boolean => state.payoutAvailableMethods.method.isLoading;
export const selectPayoutAvailableMethodLoaded = (state: RootState): boolean => state.payoutAvailableMethods.method.isLoaded;
